export function getProjectRoute(projectId: string, nodeId?: string) {
  if (nodeId) {
    return `/project/${projectId}/node/${nodeId}`;
  }

  return `/project/${projectId}`;
}
